import Vue from 'vue'
import Vuex from 'vuex'
import VuexPersist from 'vuex-persist'

Vue.use(Vuex)

const vuexSessionStorage = new VuexPersist({
    key: 'clientes.api.v1',
    storage: window.localStorage
});

export default new Vuex.Store({
  state: {
  	auth: function(state, key) {
  		return state.auth ? state.auth : null;
  	}
    ,noLeidas: 0
  },
  mutations: {
  	set: function(state, value) {
  		state = Object.assign(state, value);
  	}
    ,refreshCredentials: function(state, value) {
      state.auth.token = value.token;
      state.auth.exp = value.exp;
    }
    ,setNoLeidas: function(state, value) {
      state.noLeidas = value;
    }
    ,logout: function(state, value) {
      state = {auth:null, cliente:null, noLeidas: null, creditos: []};
    },

    setTokenFinerio (state, token) {
      state.token_finerio = token
    },

  },
  actions: {

  },
  getters:{
    getTokenFinerio( state) {
      return state.token_finerio
    },
  },
  plugins: [vuexSessionStorage.plugin]
})
